import React, { useMemo } from "react";

import { Menu, Dropdown as DropdownBase } from "antd";
import PropTypes from "prop-types";

import styles from "./styles";
import "antd/dist/antd.css";
import "./styles.scss";

const Dropdown = ({ items, label, icon }) => {
  const menu = useMemo(
    () => (
      <Menu>
        {items.map(({ key, label: _label, ...rest }) => (
          <Menu.Item key={`dropdown:${key}`} {...rest}>
            {_label}
          </Menu.Item>
        ))}
      </Menu>
    ),
    [],
  );

  return (
    <DropdownBase
      style={styles.floatRight}
      className="dropdown-btn"
      overlay={menu}>
      <div>
        <span className="dropdown-btn-label">{label}</span>
        {icon}
      </div>
    </DropdownBase>
  );
};

Dropdown.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired,
    }),
  ).isRequired,
  icon: PropTypes.node.isRequired,
  label: PropTypes.string,
};

export default Dropdown;
